document.querySelectorAll('.navbar-toggler, .close_btn').forEach(item => item.addEventListener('click', (e) => {
    document.body.classList.toggle('overflow-hidden')
}))
document.querySelectorAll('.toggleSearch').forEach(item => item.addEventListener('click', (e) => {
    e.preventDefault();
    const searchForm = document.querySelector('.search-form-wrapper');
    searchForm.classList.toggle('active');
}))
document.querySelector('.navbar-toggler').addEventListener('click', function(e){
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
})


const hotspotDots = document.querySelectorAll('.dot-toggle');
const hotSpotDiv =  document.querySelectorAll('.hotspot');
// Add the click event to each dot toggle
if (hotspotDots) {
    document.querySelectorAll('.dot-toggle').forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            const nextItem = item.nextElementSibling;

            if (nextItem.classList.contains('is-active')) {
                nextItem.classList.remove('is-active');
                return;
            }

            const activeItem = document.querySelector('.dot-wrapper.is-active');
            if (activeItem) {
                activeItem.classList.remove('is-active');
            }
            nextItem.classList.add('is-active');

            window.addEventListener('click', function closeHotspot(e) {
                if (!nextItem.contains(e.target) && !item.contains(e.target)) {
                    nextItem.classList.remove('is-active');
                    window.removeEventListener('click', closeHotspot);
                }
            });
        });
    });

}

const quotesReadMoreButtons = document.querySelectorAll('.word-quotes .read-more');
if(quotesReadMoreButtons){
    quotesReadMoreButtons.forEach(item => {
        item.addEventListener('click', e => {
            e.preventDefault();
            this.classList.toggle('is-deactive')
            this.previousElementSibling.classList.toggle('is-active')
        })
    })
}


const scrollToTop = document.querySelector('.scroll-bottom');
if(scrollToTop) {
    scrollToTop.addEventListener('click', function (e){
        window.scrollTo({top : document.querySelector('.entry-content').offsetTop - 50})
    })
}